//该文件专门用于创建整个应用的路由器
import VueRouter from "vue-router";

import modelparam from "../pages/modelparam";
import modifyPassword from "@/pages/modifyPassword";
import home from "@/pages/home";
import navigation from "@/pages/navigation";
import analysis from "@/pages/analysis";
import addUser from "@/pages/addUser";
import blacklist from "@/pages/blacklist";
import roleManage from "@/pages/roleManage";
import userList from "@/pages/userList";
import modelManage from "@/pages/modelManage";
import ofAccount from "@/pages/ofAccount";

//创建一个路由器
const router = new VueRouter({
    routes:[
        {
            path:'/home',
            component:home,
            meta:{
                title:'登录 | KLUKE'
            }
        },
        {
            path:'/navigation',
            component:navigation,
            meta:{
                title:'主页 | KLUKE'
            },
            children:[
                {
                    name:'Modelparam',
                    path:'modelparam',
                    component:modelparam,
                    meta:{
                        isAuth:true,
                        title:'模型参数',
                    }
                },
                {
                    name:'ModelManage',
                    path:'modelManage',
                    component:modelManage,
                    meta:{
                        isAuth:true,
                        title:'模型管理',
                    }

                },
                {
                    name:'ModifyPassword',
                    path:'modifyPassword',
                    component:modifyPassword,
                    meta:{
                        isAuth:true,
                        title:'账户设置'
                    }
                },
                {
                    name:'ofAccount',
                    path:'ofAccount',
                    component:ofAccount,
                    meta:{
                        isAuth:true,
                        title:'注销账号'
                    }
                },
                {
                    name:'Analysis',
                    path:'analysis',
                    component:analysis,
                    meta:{
                        isAuth:true,
                        title:'订单管理',
                    }
                },
                {
                    name:'AddUser',
                    path:'addUser',
                    component:addUser,
                    meta:{
                        isAuth:true,
                        title:'添加用户',
                    }
                },
                {
                    name:'Blacklist',
                    path:'blacklist',
                    component:blacklist,
                    meta:{
                        isAuth:true,
                        title:'黑名单管理',
                    }
                },
                {
                    name:'RoleManage',
                    path:'roleManage',
                    component:roleManage,
                    meta:{
                        isAuth:true,
                        title:'角色管理',
                    }
                },
                {
                    name:'UserList',
                    path:'userList',
                    component:userList,
                    meta:{
                        isAuth:true,
                        title:'用户查询',
                    }
                }
            ]
        },

    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})

/*router.beforeEach((to, from, next) => {
    console.log('前置路由守卫', to, from);
    if (to.meta.isAuth) { //判断当前路由是否需要进行权限控制
        if (localStorage.getItem('token')) { //控制权限的具体规则
            document.title = to.meta.title??'';
            next() //放行
        }
    }
})*/

export default router;
